import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';


@Component({
  selector: 'fpx-number',
  templateUrl: './fpx-number.component.html',
  styleUrls: ['./fpx-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxNumberComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxNumberComponent extends BaseFpxControlComponent {
  
  @Input() mask:string = '0*';
  @Input() maxLength:string;

  constructor(controlContainer: ControlContainer, changeDetectorRef: ChangeDetectorRef) {
    super(controlContainer, changeDetectorRef);
  }

  protected doPreInit(): void {
    
  }

}
